module.exports = __webpack_public_path__ + "static/img/mainbusiness02.2e3978e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sub/01/mainbusiness02.png
// module id = McEp
// module chunks = 1